export default "__VITE_ASSET__Bk727wit__"